import { NavBar } from "@/components/NavBar"
import './MPaper.scss'
import produce from 'immer';
import { useNavigate } from "react-router-dom";
import { AnswerPaperModel, QuestionModel } from "@/models/typing";
import { atom, useRecoilCallback, useRecoilState, useRecoilValue } from "recoil";
import { quizState } from "@/models/quizState";
import { formatTime, isMobile } from "@/utils/util";
import { Tracking } from "@/utils/tracking";
import { countdownState } from "./MQuiz";
import BlankPage from "@/components/Error/blank";
import { QuizAlert } from "@/components/Alert";


export const paperState = atom<AnswerPaperModel>({
    key: 'paperState',
    default: {
        answer_log_id: "",
        answer_time: "",
        question_count: "",
        error_count: "",
        correct_pre: 0,
        questionnaire_title: "",
        error_question_list: [],
    }
})



export type PaperInfoLabelProps = {
    title: string;
    subtitle: string;
}

export const PaperInfoLabel = ({ title, subtitle }: PaperInfoLabelProps) => {

    return (
        <div className={isMobile() ? 'paper-info-label' : 'pc-paper-info-label'}>
            <p className="title">{title}</p>
            <p className="subtitle">{subtitle}</p>
        </div>
    )

}

export const PaperInfoComponent = ({ displayFlauntButton }: { displayFlauntButton: boolean }) => {

    const navigate = useNavigate()

    const paper = useRecoilValue(paperState)

    const [quiz, setQuiz] = useRecoilState(quizState)

    const countdown = useRecoilValue(countdownState)

    const percent = `正确率\n${paper.correct_pre}%`
    const message = `恭喜！\n您已完成本次${paper.questionnaire_title}答题，正确率高达${paper.correct_pre}%！ \n快去和其他勇士炫耀吧~`

    const filteredErrorQuestion = useRecoilCallback(({ snapshot }) => () => {
        const questionList = snapshot.getLoadable(quizState).contents.questionList
        const errorList = snapshot.getLoadable(paperState).contents.error_question_list
        const filteredList = questionList.filter((item: QuestionModel) => {
            return errorList.find((item2: QuestionModel) => { return item2.question_id === item.question_id })
        })
        setQuiz(produce(quiz, (draftState) => {
            draftState.questionList = filteredList
            draftState.index = 0
        }))
        navigate('/analysis')
    })

    

    return (
        <div className={isMobile() ? 'mobile-paper-view' : 'desktop-paper-view'}>
            <div className='paper-content'>
                <div className="paper-content-info">
                    <div className="paper-content-info-percent">
                        <p>{percent}</p>
                    </div>
                    <div className="paper-content-info-text">
                        {
                            (quiz.questionnaire && quiz.questionnaire.answer_time > 0) && <PaperInfoLabel title="答题时长" subtitle={formatTime(quiz.questionnaire.answer_time - countdown)} />
                        }
                        <PaperInfoLabel title="答题数" subtitle={paper.question_count} />
                        <PaperInfoLabel title="错题数" subtitle={paper.error_count} />
                    </div>
                </div>
                <p className="paper-content-message">{message}</p>
                {
                    displayFlauntButton && <div className="paper-content-show pointer" onClick={() => {
                        Tracking.UP('click_all_answer_QuestionBank_share')
                        if (isMobile()){
                            navigate('/flaunt/' + paper.answer_log_id + '/' + `${Math.random()}` )
                        }else{
                            navigate('/share/' + paper.answer_log_id + '/' + (quiz.questionnaire?.questionnaire_id ?? ''))
                        }
                    }}></div>
                }
                {
                    ((quiz.questionnaire?.is_analysis ?? 0) == 1 &&  paper.correct_pre != 100) && <div className="paper-content-error pointer" onClick={() => {
                        Tracking.UP('click_all_answer_QuestionBank_analysis')
                        filteredErrorQuestion()
                    }}></div>
                }
            </div>
        </div>

    )

}



export const MobilePaper = () => {

    const navigate = useNavigate()

    const quiz = useRecoilValue(quizState)

    if (quiz.questionList.length === 0) {
        return <BlankPage />
    }

    return (
        <div className="mobile-paper">
            <NavBar backTitle="返回首页"
                onBackClick={() => {
                    navigate('/', { replace: true })
                }}
            />
            <PaperInfoComponent displayFlauntButton={true} />
            {quiz.alert && <QuizAlert />}
        </div>
    )

}



